import styled from 'styled-components';

const collapsedStyles = `
  left: 85%;
  margin: 0;
  width: auto;
  transition: all 0.3s ease-out;
  padding: 3px 30px;
  min-width: 8.5rem;
`;

export const Root = styled.div(props => {
  const { isCollapsed } = props;

  return `
    position: fixed;
    left: 50%;
    bottom: 0;
    z-index: 4;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 2.25rem;
    min-height: 2rem;
    min-width: 25.5rem;
    background: #94b4c9;
    border-radius: 10px 10px 0 0;
    font-size: 0.75rem;
    transform: translateX(-50%);
    transition: all 0.3s ease-out;

    ${isCollapsed && collapsedStyles}
  `;
});

export const PanelWrapper = styled.div`
  background: #94b4c9;
  padding: 0 5px;
  border-radius: 10px 10px 0 0;
`;

export const CollapsedPanel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: auto;
  padding: 0;
  font-weight: 700;
`;

export const ExpandedPanel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  .button {
    height: 30px;
  }
`;
